import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './pages/login/login.component'
import { RecoverComponent } from './pages/login/subpages/recover/recover.component'
import { ChangepasswordComponent } from './pages/login/subpages/changepassword/changepassword.component'
import { LayoutComponent } from './pages/app/layout/layout.component'
import { HomeComponent } from './pages/app/home/home.component'
import { HelpComponent } from './pages/app/help/help.component'
import { SettingsComponent } from './pages/app/settings/settings.component'
import { UserAccountComponent } from './pages/app/settings/subpages/user-account/user-account.component'
import { GestionUsuariosComponent } from './pages/app/settings/subpages/gestion-usuarios/gestion-usuarios.component'
import { AjustesGeneralesComponent } from './pages/app/settings/subpages/ajustes-generales/ajustes-generales.component'
import { BalanzasComponent } from './pages/app/settings/subpages/balanzas/balanzas.component'
import { SocketDiagnosticoComponent } from './pages/app/settings/subpages/socket-diagnostico/socket-diagnostico.component'
import { CargaComponent } from './pages/app/carga/carga.component'
import { CamionesComponent } from './pages/app/camiones/camiones.component'
import { ContenedoresComponent } from './pages/app/contenedores/contenedores.component'
import { ContenedoresAdmComponent } from './pages/app/contenedores/subpages/contenedores-adm/contenedores-adm.component'
import { ContenedoresTiposComponent } from './pages/app/contenedores/subpages/contenedores-adm/subpages/contenedores-tipos/contenedores-tipos.component'
import { ViewContenedorComponent } from './pages/app/contenedores/subpages/contenedores-adm/subpages/view-contenedor/view-contenedor.component'
import { ContenedoresMovComponent } from './pages/app/contenedores/subpages/contenedores-mov/contenedores-mov.component'
import { ContenedoresMtnComponent } from './pages/app/contenedores/subpages/contenedores-mtn/contenedores-mtn.component'
import { MaterialesComponent } from './pages/app/materiales/materiales.component'
import { FilemanagerComponent } from './pages/app/filemanager/filemanager.component';

import { VerRegistrosComponent }from './pages/app/registros/ver-registros/ver-registros.component'
import { RegistroComponent }from './pages/app/registros/ver-registros/subpages/registro/registro.component'

import { ClasificarRegistrosComponent }from './pages/app/registros/clasificar-registros/clasificar-registros.component'
import { ClasificacionComponent }from './pages/app/registros/clasificar-registros/subpages/clasificacion/clasificacion.component'


import { LoggedGuard } from './services/guards/logged/logged.guard';
import { AdminGuard } from './services/guards/admin/admin.guard';
import { UserGuard } from './services/guards/user/user.guard';
import { SocketDiagnosticoGuard } from './services/guards/socket-diagnostico/socket-diagnostico.guard';
import { AppUpdateOverlayComponent } from './pages/app/shared/components/app-update-overlay/app-update-overlay.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'actualizando', component: AppUpdateOverlayComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full'},
  { path: 'recover', component: RecoverComponent, pathMatch: 'full'},
  { path: 'changepassword/:token', component: ChangepasswordComponent, pathMatch: 'full'},
  { path: 'home', redirectTo: 'dashboard/home', pathMatch: 'full'},
  { path: 'settings', redirectTo: 'dashboard/settings', pathMatch: 'full'},
  { path: 'useraccount', redirectTo: 'dashboard/useraccount', pathMatch: 'full'},
  { path: 'usersaccounts', redirectTo: 'dashboard/usersaccounts', pathMatch: 'full'},
  { path: 'generalsettings', redirectTo: 'dashboard/generalsettings', pathMatch: 'full'},
  { path: 'balanzas', redirectTo: 'dashboard/balanzas', pathMatch: 'full'},
  { path: 'socket-diagnostico', redirectTo: 'dashboard/socket-diagnostico', pathMatch: 'full'},
  { path: 'carga', redirectTo: 'dashboard/carga', pathMatch: 'full'},
  { path: 'camiones', redirectTo: 'dashboard/camiones', pathMatch: 'full'},
  { path: 'contenedores', redirectTo: 'dashboard/contenedores', pathMatch: 'full'},
  { path: 'contenedores-adm', redirectTo: 'dashboard/contenedores-adm', pathMatch: 'full'},
  { path: 'contenedor/:id', redirectTo: 'dashboard/contenedor', pathMatch: 'full'},
  { path: 'contenedores-tipos', redirectTo: 'dashboard/contenedores-tipos', pathMatch: 'full'},
  { path: 'contenedores-mov', redirectTo: 'dashboard/contenedores-mov', pathMatch: 'full'},
  { path: 'contenedores-mtn', redirectTo: 'dashboard/contenedores-mtn', pathMatch: 'full'},
  { path: 'residuos', redirectTo: 'dashboard/residuos', pathMatch: 'full'},
  { path: 'filemanager', redirectTo: 'dashboard/filemanager', pathMatch: 'full'},

  { path: 'ver-registros', redirectTo: 'dashboard/ver-registros', pathMatch: 'full'},
  { path: 'ver-registro/:id', redirectTo: 'dashboard/ver-registro', pathMatch: 'full'},
  { path: 'clasificar-registros', redirectTo: 'dashboard/clasificar-registros', pathMatch: 'full'},
  { path: 'clasificar-registro/:id', redirectTo: 'dashboard/clasificar-registro', pathMatch: 'full'},
  { path: 'buscar-registros', redirectTo: 'dashboard/ver-registros', pathMatch: 'full'},

  { path: 'dashboard', component: LayoutComponent, canActivate: [LoggedGuard], children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'help', component: HelpComponent},
      { path: 'settings', component: SettingsComponent },
      { path: 'useraccount', component: UserAccountComponent },
      { path: 'usersaccounts', component: GestionUsuariosComponent},
      { path: 'generalsettings', component: AjustesGeneralesComponent},
      { path: 'balanzas', component: BalanzasComponent},
      { path: 'socket-diagnostico', component: SocketDiagnosticoComponent, canActivate: [SocketDiagnosticoGuard]},
      { path: 'carga', component: CargaComponent},
      { path: 'camiones', component: CamionesComponent},
      { path: 'contenedores', component: ContenedoresComponent},
      { path: 'contenedores-adm', component: ContenedoresAdmComponent},
      { path: 'contenedor/:id', component: ViewContenedorComponent},
      { path: 'contenedores-tipos', component: ContenedoresTiposComponent},
      { path: 'contenedores-mov', component: ContenedoresMovComponent},
      { path: 'contenedores-mtn', component: ContenedoresMtnComponent},
      { path: 'residuos', component: MaterialesComponent},

      { path: 'ver-registros', component: VerRegistrosComponent},
      { path: 'ver-registro/:id', component: RegistroComponent},
      { path: 'clasificar-registros', component: ClasificarRegistrosComponent},
      { path: 'clasificar-registro/:id', component: ClasificacionComponent},
      { path: 'buscar-registros', redirectTo: 'ver-registros', pathMatch: 'full'},

      { path: 'filemanager', component: FilemanagerComponent, canActivate: [AdminGuard]},
      { path: '**', component: HomeComponent },
    ]
  },

  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
